import { render, staticRenderFns } from "./addNotepad.vue?vue&type=template&id=04fc6a82"
import script from "./addNotepad.vue?vue&type=script&lang=js"
export * from "./addNotepad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports